import { defineMessages, useIntl } from 'react-intl';
import { useMemo } from 'react';
import { AccordionColorPickerSection } from './accordion-color-picker';
import { type WhiteLabelingPropertyIdNew } from 'js/sign-components/common/white-labeling-new';

const messages = defineMessages({
  primaryButtonSectionLabel: {
    id: '',
    description: 'Primary Button sectionLabel',
    defaultMessage: 'Primary button colors',
  },
  primaryButtonColorLabel: {
    id: '',
    description: 'Primary Button color label',
    defaultMessage: 'Primary button color',
  },
  primaryButtonColorHoverLabel: {
    id: '',
    description: 'Primary Button hover color label',
    defaultMessage: 'Primary button hover color',
  },
  primaryButtonTextColorLabel: {
    id: '',
    description: 'Primary Button text color label',
    defaultMessage: 'Primary button text color',
  },
  primaryButtonTextColorHoverLabel: {
    id: '',
    description: 'Primary Button text hover color label',
    defaultMessage: 'Primary button text hover color',
  },
  secondaryButtonSectionLabel: {
    id: '',
    description: 'Secondary Button sectionLabel',
    defaultMessage: 'Secondary button colors',
  },
  secondaryButtonColorLabel: {
    id: '',
    description: 'Secondary Button color label',
    defaultMessage: 'Secondary button color',
  },
  secondaryButtonColorHoverLabel: {
    id: '',
    description: 'Secondary Button hover color label',
    defaultMessage: 'Secondary button hover color',
  },
  secondaryButtonTextColorLabel: {
    id: '',
    description: 'Secondary Button text color label',
    defaultMessage: 'Secondary button text color',
  },
  secondaryButtonTextColorHoverLabel: {
    id: '',
    description: 'Secondary Button text hover color label',
    defaultMessage: 'Secondary button text hover color',
  },
  backgroundColorsSectionLabel: {
    id: '',
    description: 'Background Color sectionLabel',
    defaultMessage: 'Background colors',
  },
  pageBackgroundColorLabel: {
    id: '',
    description: 'Page background color label',
    defaultMessage: 'Page background color',
  },
  headerBackgroundColorLabel: {
    id: '',
    description: 'Header background color label',
    defaultMessage: 'Header background color',
  },
  textColorsSectionLabel: {
    id: '',
    description: 'Text Colors Section Label',
    defaultMessage: 'Text colors',
  },
  linkColorLabel: {
    id: '',
    description: 'Link Color Label',
    defaultMessage: 'Link color',
  },
  textColor1Label: {
    id: '',
    description: 'Text Color 1 Label',
    defaultMessage: 'Text color 1',
  },
  textColor2Label: {
    id: '',
    description: 'Text Color 2 Label',
    defaultMessage: 'Text color 2',
  },
});
export const useSectionsNew = () => {
  const intl = useIntl();

  return useMemo<AccordionColorPickerSection<WhiteLabelingPropertyIdNew>[]>(
    () => [
      {
        sectionId: 'primary-button',
        sectionLabel: intl.formatMessage(messages.primaryButtonSectionLabel),
        items: [
          {
            id: 'primaryButtonColor',
            label: intl.formatMessage(messages.primaryButtonColorLabel),
          },
          {
            id: 'primaryButtonColorHover',
            label: intl.formatMessage(messages.primaryButtonColorHoverLabel),
          },
          {
            id: 'primaryButtonTextColor',
            label: intl.formatMessage(messages.primaryButtonTextColorLabel),
          },
          {
            id: 'primaryButtonTextColorHover',
            label: intl.formatMessage(
              messages.primaryButtonTextColorHoverLabel,
            ),
          },
        ],
      },
      {
        sectionId: 'secondary-button',
        sectionLabel: intl.formatMessage(messages.secondaryButtonSectionLabel),
        items: [
          {
            id: 'secondaryButtonColor',
            label: intl.formatMessage(messages.secondaryButtonColorLabel),
          },
          {
            id: 'secondaryButtonColorHover',
            label: intl.formatMessage(messages.secondaryButtonColorHoverLabel),
          },
          {
            id: 'secondaryButtonTextColor',
            label: intl.formatMessage(messages.secondaryButtonTextColorLabel),
          },
          {
            id: 'secondaryButtonTextColorHover',
            label: intl.formatMessage(
              messages.secondaryButtonTextColorHoverLabel,
            ),
          },
        ],
      },
      {
        sectionId: 'background-colors',
        sectionLabel: intl.formatMessage(messages.backgroundColorsSectionLabel),
        items: [
          {
            id: 'pageBackgroundColor',
            label: intl.formatMessage(messages.pageBackgroundColorLabel),
          },
          {
            id: 'headerBackgroundColor',
            label: intl.formatMessage(messages.headerBackgroundColorLabel),
          },
        ],
      },
      {
        sectionId: 'text-colors',
        sectionLabel: intl.formatMessage(messages.textColorsSectionLabel),
        items: [
          {
            id: 'linkColor',
            label: intl.formatMessage(messages.linkColorLabel),
          },
          {
            id: 'textColor1',
            label: intl.formatMessage(messages.textColor1Label),
          },
          {
            id: 'textColor2',
            label: intl.formatMessage(messages.textColor2Label),
          },
        ],
      },
    ],
    [intl],
  );
};
